module.exports = __webpack_public_path__ + "img/benz.7f2141b6.svg";